import { createContext } from '@lit/context';
import { LitElement } from 'lit';

import { PrintExampleService } from '@/api-sdk';

export interface PrintExampleType {
  uuid: string;
  filename: string;
  url: string;
}

export const printExample = {
  /**
   * Current unique value of the print example data saved in the context
   */
  context: createContext<PrintExampleType | undefined>(
    Symbol('print-example-context'),
  ),
  updateProviderEvent(
    element: LitElement,
    printExampleContext?: PrintExampleType,
  ) {
    element.dispatchEvent(
      new CustomEvent('update-print-example', {
        composed: true,
        detail: { printExample: printExampleContext },
      }),
    );
  },
  /**
   * Save print example
   *
   * @param printExampleContext {PrintExampleType}
   * @param configurationId {string}
   */
  async save(printExampleContext?: PrintExampleType, configurationId?: string) {
    if (printExampleContext && configurationId) {
      await PrintExampleService.putSavePrintExampleForConfiguration({
        uuid: configurationId,
        requestBody: { printExampleId: printExampleContext.uuid },
      });
    }
  },
};
